import { CommonErrors } from '../common-errors';
import {
  ComposerSectionProps,
  ComposerSectionValidator,
  ComposerSectionValidatorArgs,
  ValidatorErrors,
} from '../types';

export const createSectionValidator =
  <P extends ComposerSectionProps>() =>
  <const TErrors extends ValidatorErrors>(validator: {
    errors: TErrors;
    validate: (args: ComposerSectionValidatorArgs<P, TErrors, typeof CommonErrors>) => Promise<void> | void;
  }): ComposerSectionValidator<P, TErrors, typeof CommonErrors> => {
    return validator;
  };
